'use client'

import dynamic from 'next/dynamic'
import { Suspense, useCallback, useState } from 'react'
import { Skeleton } from '@/components/skeleton'
import { SlidingPane } from '@/components/sliding-pane'
import { CitiesList } from '@/features/cities/cities-list'
import { SvgOutlinedChevronRight } from '@/icons/svg-outlined-chevron-right'

// This was one horrific bug where react broke while rendering the component on the server
// Only solveable (as of march 2022) by using dynamic imports
const HeaderLabel = dynamic(() => import('./restaurant-city-mobile-navigation-header-label'), {
    ssr: false,
    loading: () => <Skeleton className="h-[24px] w-[80px]" />,
})

interface IRestaurantCityMobileNavigationHeaderProps {
    citySlug: string
}

export const RestaurantCityMobileNavigationHeader = ({
    citySlug,
}: IRestaurantCityMobileNavigationHeaderProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const onAfterCitySelect = useCallback(() => {
        setIsOpen(false)
    }, [])

    return (
        <div className="relative px-2">
            <div
                className="webkit-tap-transparent gap-x-1 flex items-center"
                onClick={() => setIsOpen(true)}
            >
                <Suspense fallback={<Skeleton className="h-[24px] w-[80px]" />}>
                    <h3 className="text-[22px] font-bold">
                        <HeaderLabel citySlug={citySlug} />
                    </h3>
                </Suspense>

                <div className="rotate-90">
                    <SvgOutlinedChevronRight color="black" size={24} />
                </div>
            </div>

            <SlidingPane isOpen={isOpen} onClose={() => setIsOpen(false)}>
                <div className="px-4">
                    <CitiesList selectedCitySlug={citySlug} onAfterSelect={onAfterCitySelect} />
                </div>
            </SlidingPane>
        </div>
    )
}
